import { createFileRoute } from '@tanstack/react-router';
import { BroadcastOverviewRouteView } from '@/pages/workspaces/broadcasts/broadcast/routing';

function BroadcastOverviewRoute() {
  const { broadcastId } = Route.useParams();
  return <BroadcastOverviewRouteView broadcastId={broadcastId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/',
)({
  component: BroadcastOverviewRoute,
});
